<template>
  <div class="question-mobile">
    mobile
    <div v-if="question && question.type && question.type === typeGroup" class="question-group" :class="{'evt-none': question && question.isWorked}">
      <PreviewQuestion 
        :dataSource="question"
        :questions="[question]"
        :location="0"
        :preview="true"
        :questionsData="question"
        @answerMissing="handleAnswerMissing"
      />
        <!-- @formatQuestion="getInfoQuestion" -->
      <div class="questions-child" v-if="question.listQuestionChild">
        <div v-for="(child, pos) of question.listQuestionChild" :key="pos" class="questions-child__item">
          <PreviewQuestion 
            v-if="child"
            :dataSource="child"
            :location="pos"
            :parentIndex="0"
            :isQuestionChild="true"
            :preview="true"
            :questionsData="question"
          />
            <!-- @formatQuestion="getInfoQuestion" -->
        </div>
      </div>
      <p v-if="txtMissingQuestionGroup" class="question-missing-answer color-err">{{ txtMissingQuestionGroup }}</p>
    </div>
    <div v-else-if="question && Object.keys(question).length" class="question-single" :class="{'evt-none': question && question.isWorked}">
      <PreviewQuestion 
        :dataSource="question"
        :location="0"
        :preview="true"
        @answerMissing="handleAnswerMissing"
      />
        <!-- @formatQuestion="getInfoQuestion" -->
    </div>
    <p v-else class="secondary-color-txt font-size-20 text-center">Dữ liệu đang cập nhật</p>
    <!-- <button v-if="question && !question.isWorked" type="button" class="btn btn-main btn-check-answer border-rd-20 full-width font-size-18" @click="checkAnswer">Kiểm tra</button>
    <button v-else type="button" class="btn btn-main btn-check-answer border-rd-20 full-width font-size-18" @click="handleResetAnswer">Làm lại</button>
    <ExerciseGuide v-if="question" :question="question" :isMobile="true" /> -->

    <!-- <div v-if="question && !question.isWorked" class="question-action">
      <button type="button" @click="checkAnswer">Hoàn thành</button>
    </div> -->
    <audio v-if="actionPlayQuestionTrue" id="question_true" :src="correct" class="display-none" autoplay></audio>
    <audio v-if="actionPlayQuestionFalse" id="question_false" :src="incorrect" class="display-none" autoplay></audio>
  </div>
</template>

<script>
import { getQuestionDetail, saveUserWorkQuestion, resetResultWorkQuestion } from './../_api/'
import { mapActions } from 'vuex'
import PreviewQuestion from './../_components/question/preview-question/PreviewQuestion.vue'
import { STORE_KEY as STORE_KEY_QUESTION, TYPE_GROUP, TYPE_DRAW_SHAPE_ANSWER, TYPE_DOWN_ANSWER, TYPE_FILL_BLANK, TYPE_SELECT, TYPE_MATH_COL, TYPE_FILL_INPUT_IMG } from './../_components/question/preview-question/_store/constants'
import { STORE_KEY, LOCAL_QUESTIONS_DATA, LOCAL_SAVE_QUESTIONS_WORKED } from "./../_store/constants"
import mixinExercise from './../_store/mixinExercise'
import { setContentMediaEditorShow } from '@/modules/question/preview-question/_store/helperQuestionContent'
import ExerciseGuide from '@/modules/exercises/_components/ExerciseGuide.vue'
const correct = require('@/assets/audio/correct.mp3')
const incorrect = require('@/assets/audio/incorrect.mp3')

export default {
  name: 'ExerciseQuestionDetail',
  components: {
    PreviewQuestion,
    ExerciseGuide
  },
  mixins: [ mixinExercise ],
  data () {
    return {
      question: {},
      typeGroup: TYPE_GROUP,
      typeDrawShape: TYPE_DRAW_SHAPE_ANSWER,
      typeDownAnswer: TYPE_DOWN_ANSWER,
      typefillBlank: TYPE_FILL_BLANK,
      typeSelect: TYPE_SELECT,
      typeMatchCol: TYPE_MATH_COL,
      txtMissingQuestionGroup: '',
      correct,
      incorrect,
      actionPlayQuestionTrue: false,
      actionPlayQuestionFalse: false
    }
  },
  created () {
    this.fetchQuestionDetail()
  },
  methods: {
    ...mapActions('common', ['setLoading', 'setActionCheckQuestion']),
    ...mapActions(STORE_KEY_QUESTION, ['setQuestionData4CheckAnswer']),

    fetchQuestionDetail () {
      if (!this.$route.params.id) {
        return
      }

      this.setLoading(true)
      getQuestionDetail(this.$route.params.id).then(res => {
        if (res && res.data && !res.errors) {
          let typeQuestion = res.data.type === TYPE_GROUP ? 'group' : 'single'
          let questionContentReplace = setContentMediaEditorShow({...res.data}, typeQuestion)
          // console.log('Question res: ', res);
          this.question = questionContentReplace
          
          this.setQuestionData4CheckAnswer({...questionContentReplace})
          
        }
      }).finally(() => this.setLoading(false))
    },

    handleAnswerMissing (valErr) {
      // if(this.question.type === TYPE_GROUP) {
        this.txtMissingQuestionGroup = valErr
      // }
    },

    async checkAnswer () {
      let self = this;

      let questionGroup = self.question.type === TYPE_GROUP ? true : false

      await self.setQuestionData4CheckAnswer({...self.question, isGroup: questionGroup})

      // if(self.question.type === TYPE_GROUP) {
        self.txtMissingQuestionGroup = ''
      // }

      await self.setActionCheckQuestion(true);
      
      if (self.txtMissingQuestionGroup) {
        return false;
      }
      
      if(self.question.isTrue) {
        self.actionPlayQuestionTrue = true;
        setTimeout(() => {
          document.getElementById('question_true').play()
        }, 5)
      } else {
        self.actionPlayQuestionFalse = true;
        setTimeout(() => {
          document.getElementById('question_false').play()
        }, 5)
      }

      !self.txtMissingQuestionGroup && saveUserWorkQuestion(self.question).then(() => {
        // Function from mixins exercise
        self.fetchQuestionDetail()
        self.replaceRoutePushToApp()
      })

      setTimeout(() => {
        self.actionPlayQuestionTrue = false;
        self.actionPlayQuestionFalse = false;
      }, 4000)
    },

    handleResetAnswer () {
      let self = this;
      resetResultWorkQuestion(self.question.questionId).then(res => {
        if (res && !res.errors) {
          self.fetchQuestionDetail()
          self.replaceRoutePushToAppForResetQuestion()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .btn-check-answer {
    margin-top: 10px;
    line-height: 1.2;
    letter-spacing: 0.03em;
  }
</style>
